<template>
    <transition
        enter-active-class="transition ease-out duration-500 transform"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-out duration-200 transform"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-if="global.modals.approval.show" class="fixed inset-0 z-50 bg-dark-deep-blue">
            <div class="flex items-center justify-center min-h-full">
                <div class="container mx-4 md:mx-0 max-w-5xl text-white md:text-center">
                    <div class="grid grid-cols-2 gap-2 md:gap-0 md:flex py-2 md:my-0 md:items-baseline md:justify-center">
                        <div class="flex items-baseline">
                            <h2 class="!normal-case text-xl">
                                {{
                                    submission.personal_details.title +
                                    " " +
                                    submission.personal_details.first_name +
                                    " " +
                                    submission.personal_details.last_name
                                }}
                            </h2>
                        </div>
                        <div class="md:ml-8">
                            id:
                            <strong>{{ submission.id }}</strong>
                        </div>
                        <div class="flex items-center md:ml-8">
                             Status:
                            <StatusBadgeComponent :status="submissionStatus" class="ml-2" />
                        </div>
                        <div class="md:ml-8">
                            acc no:
                            <strong v-if="submission.custom_account_number">
                                {{ submission.custom_account_number }}
                            </strong>
                        </div>
                    </div>

                    <HrComponent class="mb-12" />

                    <h2 class="mb-8">{{ modalLabels.modalTitle }}</h2>

                    <div class="mb-12" v-if="!documents.gbg_report.file_name && !isDeletion">
                        <span class="inline-block mr-8 uppercase text-light-blue font-semibold">GBG Report</span>
                        <div class="inline-block ml-8">
                            <FileUploadComponent
                                id="gbg-report"
                                name="gbg-report"
                                label="Upload"
                                :apiEndpointUrl="'/admin/submissions/' + $route.params.user + '/gbg'"
                                :fileData="proofOfIdentityDocument"
                                @change="doGetSubmissionGbgReportDocument($route.params.user)"
                            />
                        </div>
                        <HrComponent class="mt-12" />
                    </div>

                    <div v-if="isRejection" class="mb-6 text-left">
                        <label>
                            Rejection Reason(s)
                            <textarea
                                class="w-full border bg-transparent px-6 py-4 mt-2 text-white"
                                v-model="rejectionReason"
                                placeholder="What are the reasons for rejecting this application?"
                            ></textarea>
                        </label>
                    </div>

                    <div class="mb-6 text-left" v-if="!isDeletion">
                        <label>
                            Additional Observations/Notes
                            <textarea
                                class="w-full border bg-transparent px-6 py-4 mt-2 text-white"
                                v-model="submission.submission.notes"
                                placeholder="Please enter any observations or notes in the submission"
                                @keyup="saveSubmissionNotes()"
                            ></textarea>
                        </label>
                    </div>

                    <div class="flex justify-center">
                        <ButtonComponent
                            :isLoading="isLoading"
                            isGhost
                            :color="isRejection || isDeletion ? 'error' : 'light-blue'"
                            :label="modalLabels.buttonLabel"
                            @click="
                                $emit('approval', {
                                    approvalType: global.modals.approval.approval_type,
                                    reason: rejectionReason,
                                })
                            "
                        />
                        <ButtonComponent
                            class="ml-4"
                            isGhost
                            color="transparent"
                            label="Cancel"
                            @click="$emit('close')"
                        />
                    </div>
                    <AlertComponent
                        class="mt-6"
                        v-if="hasError"
                        message="There was a problem approving this submission. You cannot approve this submission twice, or the submission may have been recently rejected by someone else."
                    />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonStatusComponent from "@adminComponents/buttons/ButtonStatusComponent";
import HrComponent from "@adminComponents/misc/HrComponent";
import ButtonComponent from "@adminComponents/buttons/ButtonComponent";
import FileUploadComponent from "@adminComponents/inputs/FileUploadComponent";

export default {
    name: "ApprovalModalComponent",
    components: {
        ButtonStatusComponent,
        HrComponent,
        ButtonComponent,
        FileUploadComponent,
    },
    props: {
        isLoading: { type: Boolean, default: false },
        hasError: { type: Boolean, default: false },
    },
    data() {
        return {
            buttonLabel: "",
            modalTitle: "",
            isRejection: false,
            isDeletion: false,
            rejectionReason: "",
            submissionNotes: "",
        };
    },
    computed: {
        ...mapGetters(["submission", "global", "documents"]),
        submissionStatus() {
            return this.submission.submission != undefined && this.submission.submission.submitted_at
                ? "Submitted"
                : "In Progress";
        },
        modalLabels() {
            switch (this.global.modals.approval.approval_type) {
                case "Deleted":
                    this.isDeletion = true;
                    this.isRejection = false;
                    return {
                        buttonLabel: "Confirm Deletion",
                        modalTitle: "Delete Application",
                    };
                case "Rejected":
                    this.isRejection = true;
                    this.isDeletion = false;
                    return {
                        buttonLabel: "Confirm Rejection",
                        modalTitle: "Reject Application",
                    };
                case "Approved":
                    this.isRejection = false;
                    this.isDeletion = false;
                    return {
                        buttonLabel: "Confirm Second Approval",
                        modalTitle: "Second Approval",
                    };
                case "First Approval":
                    this.isRejection = false;
                    this.isDeletion = false;
                    return {
                        buttonLabel: "Confirm First Approval",
                        modalTitle: "First Approval",
                    };
            }
        },
        saveSubmissionNotes(){
            this.doSaveSubmissionNotes({notes: this.submission.submission.notes});
        }
    },
    methods: {
        ...mapActions(["doGetSubmissionGbgReportDocument", "doSaveSubmissionNotes"]),
    }
};
</script>
